import React from 'react';
import './Page.css';

function Disclaimer() {
  return (
    <div className="page disclaimer-page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Disclaimer</h1>
        </div>
        
        <div className="disclaimer-section">
          <h2>Content</h2>
          <p>
            The content on this website is solely for the purpose of providing certain limited information about YK2 Partners and its services. It is not intended to constitute professional advice. YK2 Partners makes no representation as to the completeness or accuracy of the information on this website. The information may be incomplete or out of date or may contain errors.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>No offer</h2>
          <p>
            YK2 Partners is making the information available on this website as a public service and does not do so to offer any security to any person in any country. The information contained herein in no way be construed as a recommendation by YK2 Partners with respect to purchase or sale of any security. Information contained on this website is not to be used or considered as an offer or solicitation of an offer to buy or sell securities or to provide investment advice.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Limitation of liability</h2>
          <p>
            Any action on your part on the basis of information provided on the website is at your own risk and responsibility. In no event shall YK2 Partners and its affiliates share or be liable for any damage, expenses or charges of any nature arising out of you accessing or not being able to access this website.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Privacy</h2>
          <p>
            Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory. We do not use cookies on this website.
          </p>
          <p>
            We may collect information which you enter on the website and may use it for timely follow-ups. We do not transfer any of your details to outside parties. This excludes website hosting / maintenance partners who assist us in operating the website.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Downloads</h2>
          <p>
            We do not represent that there will be uninterrupted access to the website. We also do not represent that no virus or other contaminating materials will be transmitted to your computer or mobile device. It is your sole responsibility to take appropriate precautions to scan for virus and other contaminating materials.
          </p>
        </div>

        <div className="disclaimer-important">
          <p>
            <strong>Note:</strong> By visiting this website you are agreeing to the terms set out above.
          </p>
          <p>
            If you have any queries regarding any of the terms, please email at: <a href="mailto:info@yk2partners.com" aria-label="info@yk2partners.com Email YK2 Partners with disclaimer questions">info@yk2partners.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
